module.exports = __webpack_public_path__ + "static/img/b-kerry.1836a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/b-kerry.png
// module id = /fDn
// module chunks = 31